module.exports = __webpack_public_path__ + "img/kefu-on.c6d31667.png";